import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { TextField } from '@mui/material';
import { receiveProduct, getPurchaseOrder } from 'actions/EntityActions';
import { initReceivePurchaseOrder, clearFormInput } from 'actions/FormActions';
import { showSnackbar, showError } from 'actions/CommonActions';
import { getCsvReport } from 'actions/ReportsAction';
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import CardSimple from 'screens/components/basic/CardSimple';
import LOOKUP from 'constants/lookup';
import { POReasons } from 'constants/enums';
import Grid from 'screens/components/basic/Grid';
import ReceiveProductDialog from './components/receiveProductDialog';
import DialogInputNew from 'screens/components/advanced/DialogInputNew';
import { poReceiveCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
class ReceivePurchaseOrder extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            open: false,
            product: null,
            name: null,
            po: 0,
            searchText: "",
            displayProductList: []
        };

        this.amounts = [];
        this.ws = null;

        this.handleDialog = this.handleDialog.bind(this);
        this.cleanSearch = this.cleanSearch.bind(this);
        this.onChangeSearch = this.onChangeSearch.bind(this);
        this.clearSearchField = this.clearSearchField.bind(this);
    }

    componentWillMount() {
        if (this.props.params.id > 0) {
            this.props.getPurchaseOrder(this.props.params.id, this.props.branchId);
        }

        try {
            this.initWebSocket();
        }
        catch (err) {
            this.initWebSocket();
        }
    }

    componentWillReceiveProps(newProps) {
        // if receiveProductSuccess exists
        if (newProps.receiveProductSuccess !== undefined && newProps.receiveProductSuccess !== null) {
            // if new receiveProductSuccess is different from actual receiveProductSuccess
            if (newProps.receiveProductSuccessKey !== this.props.receiveProductSuccessKey) {
                // success
                if (newProps.receiveProductSuccessKey) {
                    this.props.getPurchaseOrder(this.props.params.id, this.props.branchId);
                }
                // error
                else {
                    this.props.showError(LOOKUP.transferProduct.receiveProductError);
                }
            }
        }

        if (newProps.productsInTransit && newProps.productsInTransit !== this.props.productsInTransit){
            this.getProductsFromPO(newProps.productsInTransit);
        }
    }

    componentWillUnmount = () => {
        if (this.ws) {
            this.ws.close();
        }
    }

    receiveProduct = (lot, upc, isAccessory, quantity, expirationDate = null, changeUPC = false) => {
        if (quantity) {
            const model = {
                purchaseOrderProductId: this.state.product.id,
                branchId: this.props.branchId,
                universalProductCode: (upc && upc !== '') ? upc : '',
                packageReference: lot ? lot : '',
                QuantityReceived: parseFloat(quantity),
                reason: POReasons.Purchased,
                isAccessory: isAccessory,
                expirationDate: expirationDate,
                changeUPC: changeUPC,
                THCLevel: this.props.THCLevel,
                CBDLevel: this.props.CBDLevel,
                depositAmount: this.props.depositAmount,
                THCMAX: this.props.THCMAX,
                THCMIN: this.props.THCMIN,
                CBDMAX: this.props.CBDMAX,
                CBDMIN: this.props.CBDMIN,
                salePrice: this.props.salePrice,
                memberSalePrice: this.props.memberSalePrice,
                location: this.props.receivedQuantityDialogLocation,
                notes: this.props.receivedQuantityDialogNotes
            };
            this.props.receiveProduct(model);
        }
    }

    //Otherwhise, the value cannot be retrived by props.
    handleDialog(product, name, po) {
        this.cleanSearch();
        this.setState({ open: !this.state.open, product, name, po }, () => console.log(this.state));
    }

    cleanSearch = () => {
        this.props.clearFormInput(`receivedQuantityDialog`);
        this.props.clearFormInput(`InputUPCNumber`);
    }

    onChangeSearch = (e) => {
        const searchText = e.target.value;
        this.setState({ searchText });

        if (searchText){
            const lowercasedSearchText = searchText.toLowerCase();
            const filterList = this.props.productsInTransit.filter(item => item.product.toLowerCase().includes(lowercasedSearchText));
            this.getProductsFromPO(filterList);
        }
    }

    clearSearchField = () => {
        this.setState({ searchText: ``, displayProductList: this.getProductsFromPO(this.props.productsInTransit) })
    }

    getProductsFromPO = (products) => {
        const productList = [];
        products.map((product, index) => {
            productList.push({
                Information: (
                    <div className="pt-3 pb-3" key={index}>
                        <div className="row">
                            <div className="col-xs-12">
                                <h4 className="m-0">{product.product}</h4><br />
                                <p className="font-weight-normal">SKU: {`${product.sku}`} </p>
                                <p className="font-weight-normal">Category: {`${product.type} | ${product.category}`} </p>
                                {
                                    product.packageReference && (
                                        <p className="font-weight-normal">Lot Number: {product.packageReference} </p>
                                    )
                                }
                                {
                                    product.notes && (
                                        <p className="font-weight-normal">Notes: {product.notes} </p>
                                    )
                                }
                            </div>
                        </div>
                    </div>),
                Quantity: (
                    <div className="row m-0 PO_item col-4-p-0">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                            <label>ORDERED</label>
                            <h3 className="p-0 m-0">{`${product.isUnitProduct ? product.quantity.toFixed(0) : product.quantity.toFixed(1)}`} </h3>
                            <p>{`${product.isUnitProduct ? 'unit(s)' : 'g'}`}</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                            <label>RECEIVED</label>
                            {/*Actual Qty Received*/}
                            <h3 className="p-0 m-0">{product.actualQuantity ? product.actualQuantity : 0}</h3>
                            <p>{`${product.isUnitProduct ? 'unit(s)' : 'g'}`}</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                            <label>REMAINING</label>
                            <h3 className="p-0 m-0">{product.quantity - product.actualQuantity}</h3>
                            <p>{`${product.isUnitProduct ? 'unit(s)' : 'g'}`}</p>
                            {/*Show button only when the ordered Qty it's not complete*/}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                            {
                                (product.actualQuantity < product.quantity) ?
                                    (
                                        <div className="status-product-po missing">Missing</div>
                                    )
                                    :
                                    (
                                        <div className="status-product-po received">Received</div>
                                    )
                            }
                        </div>
                    </div>
                ),
                ReceiveIcon: (product.actualQuantity < product.quantity) ?
                    (
                        <Button
                            type="IconButton"
                            className="glyphicon glyphicon-save"
                            id={`receivePoProduct-${index}`}
                            icon={<FileDownloadIcon />}
                            onTouchTap={() => this.handleDialog(product, product.product, product.purchaseOrderId)} />
                    )
                    :
                    (null)
            });

        });
        this.setState({ displayProductList: productList });
        return productList;
    };

    initWebSocket = () => {
        try {
            this.ws = new WebSocket("ws://127.0.0.1:5000/");
            this.ws.binaryType = "arraybuffer";

            this.ws.onopen = function () {
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                    // console.log('ws connected');
                }
            };

            this.ws.onerror = () => {
            };

            this.ws.onclose = (event) => {
                if (event.code !== 99999) {
                }
            };

            this.ws.onmessage = (event) => {
                let response = event.data;
                let content = response.split(',');
                let responseType = content[0];
                let value = content[1];

                if (responseType === "LABELPRINTER") {
                    if (value === 'OFFLINE') {
                        this.props.showError("The label printer is offline. Please, Contact the support team.");
                    }
                }

            };

            window.onbeforeunload = function () {
                if (this.ws) {
                    const model = {
                        Command: "CLOSE",
                        Data: null
                    };

                    this.ws.send(JSON.stringify(model));
                    this.ws.close(99999);
                    window.productWebSocket = null;
                }
            };

            window.productWebSocket = this.ws;
        }
        catch (err) {
            console.error(err);
        }
    }

    downloadCsv = () => {
        let beginDate = this.props.purchaseOrder.creationDate ? moment(this.props.purchaseOrder.creationDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branchId;
        let SKU = "";
        let POID = this.props.purchaseOrder.id;
        let vendor = this.props.vendor || 0;
        let pageNumber = 1;
        let pageSize = 999999;
        let recordTypeSelect = null

        this.props.getCsvReport(`reports/excel/poreceiver?beginDate=${beginDate}&endDate=${endDate}&SKU=${SKU}&POID=${POID}&branch=${branch}&vendor=${vendor}&pageNumber=${pageNumber}&pageSize=${pageSize}&recordTypeSelect=${recordTypeSelect}`, "poreceiver");
    }

    render() {

        return (
            <Grid headerContent={poReceiveCrumb}>
                <PageHeaderWithButton title="Receive Products">
                    <Button
                        className="bg-light-green"
                        type="DownloadButton"
                        id="exportToCSV"
                        label={"Export to CSV"}
                        onTouchTap={this.downloadCsv}
                    />
                </PageHeaderWithButton>
                {
                    this.props.purchaseOrder !== null && this.props.purchaseOrder !== undefined ?
                        <CardSimple className="p-2">
                            <h4>Purchase Order #{this.props.purchaseOrder.id}</h4>
                            <p>
                                <strong>Vendor:</strong> {this.props.purchaseOrder.vendor}<br />
                                {this.props.canViewPOTotalAmount ? <strong>Total: $ {this.props.purchaseOrder.total.toFixed(2)} </strong> : ""}
                            </p>
                        </CardSimple>
                        : ''
                }
                <CardSimple>
                    <div className="row">
                        <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 pb-2">
                            <TextField
                                type="text"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={(e) => this.onChangeSearch(e)}
                                name='receivePOSearch'
                                fullWidth={true}
                                label='Product Search' />
                        </div>
                        <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                            <Button
                                name='btnResetFilter'
                                className='mb-2'
                                label="Reset Filter"
                                primary={true}
                                onTouchTap={this.clearSearchField}
                            />
                        </div>
                    </div>
                    <GenericTable
                        columns={LOOKUP.transferProduct.tableColumnsProductPO}
                        rows={this.state.displayProductList}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        multiSelectable={false}
                        enableSelectAll={false}
                        selectable={false}
                        stripedRows={true} />
                </CardSimple>
                <DialogInputNew
                    title={"RECEIVING PO #" + this.state.po} 
                    handleClose={() => this.handleDialog()}
                    className="no_btns_dialog"
                    open={this.state.open}
                >
                    <ReceiveProductDialog
                        receivedQuantityDialog={this.props.receivedQuantityDialog}
                        InputUPCNumber={this.props.InputUPCNumber}
                        inputLotNumber={this.props.inputLotNumber}
                        productName={this.state.name}
                        purchaseProductId={this.state.po}
                        product={this.state.product}
                        receiveProduct={this.receiveProduct}
                        handleDialog={this.handleDialog}
                        cleanQty={this.cleanSearch}
                        ws={this.ws}
                    />
                </DialogInputNew>
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        productsInTransit: state.entity.productListPO,
        receiveProductSuccess: state.form.receiveProductPOSaveSuccess,
        vendor: state.form["POSaveVendorID"],
        branchId: state.common.branchId,
        receivedQuantityDialog: state.form.receivedQuantityDialog,
        InputUPCNumber: state.form.InputUPCNumber,
        inputLotNumber: state.form.InputLotNumber,
        purchaseOrder: state.entity.purchaseOrder,
        receiveProductSuccessKey: state.form.receiveProductPOSaveSuccessKey,
        THCLevel: state.form['receivedQuantityDialogTHCLevel'] || 0,
        CBDLevel: state.form['receivedQuantityDialogCBDLevel'] || 0,
        THCMAX: state.form['receivedQuantityDialogTHCMAX'] || 0,
        THCMIN: state.form['receivedQuantityDialogTHCMIN'] || 0,
        CBDMAX: state.form['receivedQuantityDialogCBDMAX'] || 0,
        CBDMIN: state.form['receivedQuantityDialogCBDMIN'] || 0,
        depositAmount: state.form['receivedQuantityDialogDepositAmount'] || 0,
        salePrice: state.form['receivedQuantityDialogSalePrice'] || 0,
        memberSalePrice: state.form['receivedQuantityDialogMemberSalePrice'] || 0,
        canViewPOTotalAmount: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewPOTotalAmount")),
        receivedQuantityDialogLocation: state.form['receivedQuantityDialogLocation'] || '',
        receivedQuantityDialogNotes: state.form['receivedQuantityDialogNotes'] || ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: () => dispatch(initReceivePurchaseOrder()),
        receiveProduct: (model) => dispatch(receiveProduct(model)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getPurchaseOrder: (id, branchId) => dispatch(getPurchaseOrder(id, branchId)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(ReceivePurchaseOrder));